import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

export default function Leaderboard({ countries }) {

  const [flash, setFlash] = useState(false);

  useEffect(() => {
    if (!countries) return;

    setFlash(true);

    const timer = setTimeout(() => {
      setFlash(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, [countries]);

  const topCountries = (countries || [])
    .filter((c) => c.top_bidders && c.top_bidders.length > 0)
    .map((country) => {

      const sortedBidders = [...country.top_bidders].sort(
        (a, b) => Number(b.amount) - Number(a.amount)
      );

      return {
        ...country,
        topBidder: sortedBidders[0]
      };

    })
    .sort((a, b) => Number(b.topBidder.amount) - Number(a.topBidder.amount))
    .slice(0, 10);

  if (topCountries.length === 0) {
    return (
      <div className={`glass-panel p-6 ${flash ? "leaderboard-flash" : ""}`}>

        <h2
          className="text-2xl font-['Cinzel'] text-[#FFD700] uppercase mb-4 flex items-center justify-center gap-2"
          style={{
            animation: "globePulse 2s ease-in-out infinite",
            textShadow:
              "0 0 8px #FFD700, 0 0 18px #FFD700, 0 0 40px rgba(255,215,0,0.6)"
          }}
        >

          <img
            src="/trophy.png"
            alt="trophy"
            style={{
              width: "30px",
              height: "30px",
              objectFit: "contain",
              marginLeft: "-18px",
              animation: "globePulse 2s ease-in-out infinite",
              filter:
                "drop-shadow(0 0 10px gold) drop-shadow(0 0 20px gold)"
            }}
          />

          Top 10 Nations

        </h2>

        <p className="text-gray-400 text-center">
          No countries claimed yet.
        </p>

      </div>
    );
  }

  return (
    <>
      <motion.div
        initial={{ opacity: 0, x: 20 }}
        animate={{ opacity: 1, x: 0 }}
        className={`glass-panel p-6 ${flash ? "leaderboard-flash" : ""}`}
      >

        <h2
          className="text-2xl font-['Cinzel'] text-[#FFD700] uppercase mb-4 flex items-center justify-center gap-2"
          style={{
            animation: "globePulse 2s ease-in-out infinite",
            textShadow:
              "0 0 8px #FFD700, 0 0 18px #FFD700, 0 0 40px rgba(255,215,0,0.6)"
          }}
        >

          <img
            src="/trophy.png"
            alt="trophy"
            style={{
              width: "30px",
              height: "30px",
              objectFit: "contain",
              marginLeft: "-18px",
              animation: "globePulse 2s ease-in-out infinite",
              filter:
                "drop-shadow(0 0 10px gold) drop-shadow(0 0 20px gold)"
            }}
          />

          Top 10 Nations

        </h2>

        <div className="space-y-3">

          {topCountries.map((country, index) => {

            const topBidder = country.topBidder;

            const avatar =
              topBidder?.avatar_url ||
              "https://cdn-icons-png.flaticon.com/512/149/149071.png";

            return (

              <motion.div
                key={country.country_code}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.05 }}
                className="flex items-center justify-between p-3 bg-[#121212] rounded border border-[#333] hover:border-[#FFD700] transition-all"
              >

                <div className="flex items-center gap-3">

                  {index === 0 ? (

                    <img
                      src="/_crown.png"
                      alt="crown"
                      style={{
                        width: "28px",
                        height: "28px",
                        objectFit: "contain",
                        animation: "globePulse 2s ease-in-out infinite",
                        filter:
                          "drop-shadow(0 0 10px gold) drop-shadow(0 0 20px gold)"
                      }}
                    />

                  ) : (

                    <div className="w-8 h-8 bg-[#1A1A1A] border border-[#333] rounded-full flex items-center justify-center font-bold text-gray-400">
                      {index + 1}
                    </div>

                  )}

                  <img
                    src={avatar}
                    alt="avatar"
                    className="w-8 h-8 rounded-full border border-[#FFD700] object-cover"
                  />

                  <div>

                    <div className="font-semibold text-white">
                      {country.country_name}
                    </div>

                    <div className="text-sm text-gray-400">
                      {topBidder?.user_name}
                    </div>

                  </div>

                </div>

                <div className="text-[#FFD700] font-bold text-lg">
                  €{Number(topBidder?.amount || 0).toFixed(2)}
                </div>

              </motion.div>

            );

          })}

        </div>

      </motion.div>
    </>
  );
}
